import { CognitoAuth } from 'amazon-cognito-auth-js';
import store from "../store";
import { actionApp_setLoginState } from "../actions";

const authObj = {
  auth: undefined,
  getTokensReqList: [],
  load: function (immediateLogin) {
    return new Promise((resolve, reject) => {
      authObj.auth = authObj.initCognitoSDK(resolve, reject);
      let curUrl = window.location.href;
      authObj.auth.parseCognitoWebResponse(curUrl);
      authObj.stripAuthInfoFromUrl();
      if (immediateLogin) {
        setTimeout(() => {
          authObj.auth.getSession();
        }, 1000);
      } else {
        if (authObj.auth.getSignInUserSession().accessToken.jwtToken !== "") {
          authObj.auth.getSession();
        }
      }
    })
  },
  initCognitoSDK: function (resolve, reject) {
    let authAdminCognitoData = {
      ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      AppWebDomain: process.env.REACT_APP_COGNITO_DOMAIN,
      TokenScopesArray: ['email', 'profile', 'openid'],
      RedirectUriSignIn: process.env.REACT_APP_COGNITO_REDIRECT_URL,
      RedirectUriSignOut: process.env.REACT_APP_COGNITO_REDIRECT_URL,
      UserPoolId: process.env.REACT_APP_COGNITO_USERPOOL_ID,
      // IdentityProvider: 'Google'
    };
    let auth = new CognitoAuth(authAdminCognitoData);
    auth.useCodeGrantFlow();
    auth.userhandler = {
      onSuccess: (result) => {
        const identity = authObj.parseJwt(result.idToken.jwtToken)
        store.dispatch(actionApp_setLoginState({ tokens: result, identity: identity }));
        resolve(result)
        authObj.resolveTokensRequests(result);
      },
      onFailure: (err) => {
        reject(err)
        authObj.rejectTokensRequests();
        localStorage.clear();
        window.location.reload();
      }
    };
    return auth;
  },
  stripAuthInfoFromUrl: function () {
    setTimeout(() => {
      const queryParams = authObj.getQueryParams()
      const { code, state, ...rest } = queryParams

      if (code) {
        const queryStr = authObj.createQueryStr(rest)
        let url = window.location.origin + window.location.pathname
        if (queryStr !== "") {
          url += "?" + queryStr
        }
        window.history.replaceState({}, document.title, url);
      }
    }, 3000);
  },
  getQueryParams: function () {
    const search = window.location.search
    const params = new URLSearchParams(search)
    let paramObj = {}
    for (var value of params.keys()) {
      paramObj[value] = params.get(value)
    }
    return paramObj
  },
  createQueryStr(params) {
    const queryString = Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
    }).join('&');
    return queryString
  },
  getTokens() {
    return new Promise(function (resolve, reject) {
      authObj.getTokensReqList.push([resolve, reject]);
      authObj.auth.getSession();
    });
  },
  resolveTokensRequests(idToken) {
    if (authObj.getTokensReqList.length > 0) {
      for (let i = 0; i < authObj.getTokensReqList.length; i++) {
        authObj.getTokensReqList[i][0](idToken);
      }
      authObj.getTokensReqList = [];
    }
  },
  rejectTokensRequests() {
    if (authObj.getTokensReqList.length > 0) {
      for (let i = 0; i < authObj.getTokensReqList.length; i++) {
        authObj.getTokensReqList[i][1]();
      }
      authObj.getTokensReqList = [];
    }
  },
  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  },
  signOut() {
    authObj.auth.signOut();
  }
}

export default authObj;